import { gql } from '@apollo/client';

export const POSICIONAR_PACIENTES_SIN_GEO = gql`
    mutation PosicionarPacientesSinGeo {
        resolverGeoposicionDePacientesSin {
            success
            message
            estaEjecutando
            fechaInicio
            totalRegistros
            progresoActual
            procesadosActual
            exitososActual
            fallidosActual
        }
    }
`;